export const Bold = ({ children }: { children: string }) => {
  return <span className="font-bold">{children}</span>;
};
